import axios from "axios";
import { BASE_HEADLESS } from "./headless";
const PUBLIC_URL = BASE_HEADLESS;
/**
 * Creates a new user
 * @returns the newly created userId
 */
const createUser = async (name?: string, answers?: any) => {
  const response = await axios.post(`${PUBLIC_URL}/api/user`, {
    name,
    ...answers,
  });
  const result = {
    msg: response.data.msg as string,
    userId: response.data.userId as string,
    slug: response.data.slug as string,
  };
  if (result.userId && result.slug) {
    return result;
  } else {
    throw new Error(result.msg);
  }
};

export { createUser };
